export default "__VITE_ASSET__6578eb6f__"